"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_CART_MAP_USER = exports.UPDATE_CART = exports.HC_CART_INFO = exports.GET_UPCOMING_ORDERS = exports.GET_MAIN_CART_SLOT = exports.GET_INDIVIDUAL_CART_SLOT_EVERY = exports.GET_INDIVIDUAL_CART_SLOT = exports.GET_HC_CART = exports.GET_COMPLETED_ORDERS = exports.GET_CART_SLOT = exports.GET_CART_COUNT = exports.DELETE_MULTIPLE_CART_ENTRY_NUMBER = exports.DELETE_CART_ENTRY_NUMBER = exports.DELETE_CART = exports.CREATE_CART = void 0;
const GET_HC_CART = exports.GET_HC_CART = 'getHcCart';
const UPDATE_CART = exports.UPDATE_CART = 'updateCart';
const UPDATE_CART_MAP_USER = exports.UPDATE_CART_MAP_USER = 'updateCartMapUser';
const CREATE_CART = exports.CREATE_CART = 'createCart';
const DELETE_CART = exports.DELETE_CART = 'deleteCart';
const DELETE_CART_ENTRY_NUMBER = exports.DELETE_CART_ENTRY_NUMBER = 'deleteCartEntryNumber';
const DELETE_MULTIPLE_CART_ENTRY_NUMBER = exports.DELETE_MULTIPLE_CART_ENTRY_NUMBER = 'deleteMultipleCartEntryNumber';
const GET_CART_COUNT = exports.GET_CART_COUNT = 'getCartCount';
const HC_CART_INFO = exports.HC_CART_INFO = 'hcCartInfo';
const GET_CART_SLOT = exports.GET_CART_SLOT = 'getCartSlot';
const GET_INDIVIDUAL_CART_SLOT = exports.GET_INDIVIDUAL_CART_SLOT = 'getIndividualCartSlot';
const GET_INDIVIDUAL_CART_SLOT_EVERY = exports.GET_INDIVIDUAL_CART_SLOT_EVERY = 'getIndividualCartSlotEvery';
const GET_MAIN_CART_SLOT = exports.GET_MAIN_CART_SLOT = 'getMainCartSlot';
const GET_UPCOMING_ORDERS = exports.GET_UPCOMING_ORDERS = 'getUpcomingOrders';
const GET_COMPLETED_ORDERS = exports.GET_COMPLETED_ORDERS = 'getCompletedOrders';